const constants = {

  // WP_CUSTOM can be set at the host level in the environment
  // variables. For example, WP_CUSTOM is set to 
  // https://elpapiprod.wpengine.com in the holly-production site
  // in Gatsby Cloud.
  WP_CUSTOM: process.env.WP_CUSTOM ? process.env.WP_CUSTOM : '',

  WP_STAGING: 'https://elpapistaging.wpengine.com',
  WP_PROD: 'https://elpapiprod.wpengine.com',

  CODE_CLEARWATER: "47",
  CODE_ONLINE: "45"
};

exports.constants = constants;